<!-- @format -->

<ng-container *transloco="let t">
  <div class="container">
    <fudis-form *ngIf="form" [formGroup]="form" [title]="" [level]="2">
      <fudis-form-header>
        <fudis-body-text variant="lg-light">{{ t("FEEDBACK.DESCRIPTION_P1") }}</fudis-body-text>
        <fudis-body-text variant="lg-light">{{ t("FEEDBACK.DESCRIPTION_P2") }}</fudis-body-text>
      </fudis-form-header>
      <fudis-form-content>
        <fudis-radio-button-group [control]="control" [label]="t('FEEDBACK.QUESTION')" class="fudis-mt-xs">
          <fudis-radio-button *ngFor="let option of options" [label]="t(option.labelKey)" [value]="option.value" />
        </fudis-radio-button-group>
        <fudis-button
          fudisFormSubmit
          [label]="t('FEEDBACK.SUBMIT')"
          [formValid]="form.valid"
          (handleClick)="onSubmit()"
          class="fudis-mt-sm" />
      </fudis-form-content>
    </fudis-form>
  </div>
</ng-container>
